export default "__VITE_ASSET__C5nM43LW__"